import { of } from 'rxjs';
import { pluck, catchError } from 'rxjs/operators';
import { fetchAsObservable } from 'fetcher!sofe';
import { checkForFailedFetch } from './resource.helpers.js';

export function getTask(taskId) {
  return fetchAsObservable(`/api/tasks/${taskId}`).pipe(
    pluck('tasks'),
    catchError(val => of(checkForFailedFetch(val)))
  );
}
